// 检测是否是 Safari 浏览器
function isSafari() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('safari') && !ua.includes('chrome');
}

// 初始化基础功能引导
function initBaseGuide() {
    // 如果是 Safari 浏览器则不显示引导
    if (isSafari()) {
        localStorage.setItem('hasVisitedBase', 'true');
        return;
    }

    // 检查是否是首次访问
    if (!localStorage.getItem('hasVisitedBase')) {
        // 配置引导步骤
        const intro = introJs();
        let autoAdvanceTimer;

        // 设置自动前进定时器
        function startAutoAdvanceTimer() {
            clearTimeout(autoAdvanceTimer);
            autoAdvanceTimer = setTimeout(() => {
                intro.nextStep();
            }, 3000);
        }

        // 清除自动前进定时器
        function clearAutoAdvanceTimer() {
            clearTimeout(autoAdvanceTimer);
        }

        intro.setOptions({
            steps: [
                {
                    title: '欢迎',
                    intro: '欢迎使用HTML代码预览工具！让我们来了解一下主要功能。'
                },
                {
                    element: document.querySelector('.editor-wrapper'),
                    title: '代码编辑区',
                    intro: '在这里编写你的HTML代码，支持实时语法高亮和自动补全。',
                    position: 'right'
                },
                {
                    element: document.querySelector('.preview-container'),
                    title: '预览区域',
                    intro: '这里会实时显示你编写的代码效果。',
                    position: 'left'
                },
                {
                    element: document.querySelector('#clear-btn'),
                    title: '清除按钮',
                    intro: '点击此按钮可以清除当前编辑器中的所有代码。'
                },
                {
                    element: document.querySelector('#paste-btn'),
                    title: '粘贴按钮',
                    intro: '点击此按钮可以快速将剪贴板中的代码粘贴到编辑器中。'
                },
                {
                    element: document.querySelector('#fullscreen-btn'),
                    title: '全屏预览',
                    intro: '点击此按钮可以全屏查看预览效果。'
                },
                {
                    element: document.querySelector('#save-btn'),
                    title: '保存代码',
                    intro: '点击此按钮可以将当前编辑的代码保存为HTML文件到本地。'
                },
                {
                    element: document.querySelector('#publish-btn'),
                    title: '上传代码',
                    intro: '点击此按钮可以上传你的代码并获取可分享的链接。'
                }
            ],
            nextLabel: '下一步 →',
            prevLabel: '← 上一步',
            skipLabel: '跳过',
            doneLabel: '完成',
            showProgress: true,
            exitOnOverlayClick: false,
            showBullets: true,
            showStepNumbers: true,
            tooltipClass: 'customTooltip',
            disableInteraction: true
        });

        // 每次改变步骤时重置定时器
        intro.onbeforechange(function() {
            startAutoAdvanceTimer();
        });

        // 用户手动操作时清除定时器
        intro.onchange(function() {
            clearAutoAdvanceTimer();
            startAutoAdvanceTimer();
        });

        // 引导结束后标记已访问并清除定时器
        intro.oncomplete(function() {
            clearAutoAdvanceTimer();
            localStorage.setItem('hasVisitedBase', 'true');
        });

        // 如果用户跳过引导也标记已访问并清除定时器
        intro.onexit(function() {
            clearAutoAdvanceTimer();
            localStorage.setItem('hasVisitedBase', 'true');
        });

        // 启动引导并开始定时器
        intro.start();
        startAutoAdvanceTimer();
    }
}

// 初始化错误控制台引导
function initConsoleGuide() {
    // 如果是 Safari 浏览器则不显示引导
    if (isSafari()) {
        localStorage.setItem('hasVisitedConsole', 'true');
        return;
    }

    // 检查是否是首次查看控制台
    if (!localStorage.getItem('hasVisitedConsole')) {
        const intro = introJs();
        let autoAdvanceTimer;

        // 设置自动前进定时器
        function startAutoAdvanceTimer() {
            clearTimeout(autoAdvanceTimer);
            autoAdvanceTimer = setTimeout(() => {
                intro.nextStep();
            }, 5000);
        }

        // 清除自动前进定时器
        function clearAutoAdvanceTimer() {
            clearTimeout(autoAdvanceTimer);
        }

        intro.setOptions({
            steps: [
                {
                    element: document.querySelector('.console-container'),
                    title: '错误控制台',
                    intro: '这里会显示代码中的错误信息，帮助你快速定位和解决问题。',
                    position: 'top'
                },
                {
                    element: document.querySelector('.copy-error-btn'),
                    title: '复制错误信息',
                    intro: '点击此按钮可以复制完整的错误信息，复制然后粘贴到DeepSeek就可以帮你解决问题。',
                    position: 'left'
                }
            ],
            nextLabel: '下一步 →',
            prevLabel: '← 上一步',
            skipLabel: '跳过',
            doneLabel: '完成',
            showProgress: false,
            exitOnOverlayClick: false,
            showBullets: true,
            showStepNumbers: false,
            tooltipClass: 'customTooltip',
            disableInteraction: true
        });

        // 每次改变步骤时重置定时器
        intro.onbeforechange(function() {
            startAutoAdvanceTimer();
        });

        // 用户手动操作时清除定时器
        intro.onchange(function() {
            clearAutoAdvanceTimer();
            startAutoAdvanceTimer();
        });

        // 引导结束后标记已访问并清除定时器
        intro.oncomplete(function() {
            clearAutoAdvanceTimer();
            localStorage.setItem('hasVisitedConsole', 'true');
        });

        // 如果用户跳过引导也标记已访问并清除定时器
        intro.onexit(function() {
            clearAutoAdvanceTimer();
            localStorage.setItem('hasVisitedConsole', 'true');
        });

        // 启动引导并开始定时器
        intro.start();
        startAutoAdvanceTimer();
    }
}

// 页面加载完成后初始化基础引导
window.addEventListener('load', initBaseGuide);

// 添加重置引导的功能
function resetGuide() {
    localStorage.removeItem('hasVisitedBase');
    localStorage.removeItem('hasVisitedConsole');
    initBaseGuide();
}

// 导出函数供其他文件使用
window.initBaseGuide = initBaseGuide;
window.initConsoleGuide = initConsoleGuide;
window.resetGuide = resetGuide; 